import React from 'react';
import { CheckCircle } from 'react-feather';

import { TranslatedLink } from '@/utils/translatedComponents';

import styles from './ProgressBar.module.css';

interface ProgressBarProps {
  activeStep?: number;
  steps?: {
    display: string;
    href?: string;
  }[];
}

export function ProgressBar({ activeStep = 0, steps = [] }: ProgressBarProps) {
  if (!steps.length) return null;

  return (
    <div className={styles.progressBar}>
      {steps.map((step, index) => {
        const RenderComponent = step.href ? TranslatedLink : ('div' as TypeAny);

        return (
          <React.Fragment key={step.display.replace(/\s/g, '')}>
            {index > 0 && (
              <span className={styles.progressBarItemSeparator} data-is-next={index > activeStep} />
            )}

            <div
              className={styles.progressBarItem}
              data-is-active={activeStep === index && activeStep > -1}
              data-is-next={index > activeStep || activeStep === -1}
            >
              <RenderComponent href={step.href}>
                {index < activeStep && <CheckCircle className={styles.progressBarItemIcon} />}

                <span className={styles.progressBarItemText}>{step.display}</span>
              </RenderComponent>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}
